import { render, staticRenderFns } from "./AvailableRoomsCard.vue?vue&type=template&id=58f58522"
import script from "./AvailableRoomsCard.vue?vue&type=script&lang=js"
export * from "./AvailableRoomsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports